import { render, staticRenderFns } from "./Income.vue?vue&type=template&id=1f248852&scoped=true&"
import script from "./Income.vue?vue&type=script&lang=js&"
export * from "./Income.vue?vue&type=script&lang=js&"
import style0 from "./Income.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Income.vue?vue&type=style&index=1&id=1f248852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f248852",
  null
  
)

component.options.__file = "Income.vue"
export default component.exports